/* Initialize school finders on desktop, mobile, and in the theme editor. */
(() => {
  const initFinders = (root = document) => {
    root.querySelectorAll('[data-sharp-team-finder]').forEach((form) => {
      if (form.dataset.sharpReady) return;
      const select = form.querySelector('[data-sharp-team-select]');
      if (!select) return;
      form.dataset.sharpReady = 'true';
      form.hidden = false;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!select.reportValidity()) return;
        try {
          const target = new URL(select.value, window.location.origin);
          if (target.origin !== window.location.origin) return;
          if (!target.pathname.startsWith('/collections/') && target.pathname !== '/pages/contact-sharp-athletics') return;
          const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewId) target.searchParams.set('preview_theme_id', previewId);
          window.location.assign(target.href);
        } catch (error) {
          console.warn('Unable to open the selected team shop.', error);
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFinders(), { once: true });
  else initFinders();
  document.addEventListener('shopify:section:load', (event) => initFinders(event.target));
})();

(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  if (window.location.pathname === '/' || window.location.pathname === '') {
    document.body.classList.add('sharp-home-card-rounding');
  }

  const topList = nav.querySelector('.list-menu--inline');
  if (!topList) return;

  const menus = Array.from(topList.children)
    .map((item) => item.querySelector('header-menu'))
    .filter(Boolean);
  if (!menus.length) return;

  const header = nav.closest('header');
  const getDetails = (menu) => Array.from(menu.children).find((child) => child.tagName === 'DETAILS');

  const curateMenMenu = () => {
    const menMenu = menus.find((menu) => {
      const summary = getDetails(menu)?.querySelector(':scope > summary');
      return summary?.textContent?.trim().toUpperCase().startsWith('MEN');
    });
    if (!menMenu) return;
    const details = getDetails(menMenu);
    if (!details) return;

    details.querySelectorAll('.sharp-mega-menu__link').forEach((link) => {
      const title = link.textContent.trim();
      if (title !== 'Adult Compression Wear') return;
      link.dataset.sharpPreview = 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-men-compression-running-fall.png?v=1790728366';
      link.dataset.sharpPreviewLabel = 'Adult Compression Wear';
      link.dataset.sharpPreviewPosition = '50% 42%';
    });
  };
  curateMenMenu();

  const curateWomenMenu = () => {
    const womenMenu = menus.find((menu) => {
      const summary = getDetails(menu)?.querySelector(':scope > summary');
      return summary?.textContent?.trim().toUpperCase().startsWith('WOMEN');
    });
    if (!womenMenu) return;
    const details = getDetails(womenMenu);
    if (!details) return;

    const womenPreviews = {
      'Compression Wear': 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-women-ultra-fit.jpg?v=1789171749',
      'Ultra Fit Shirts': 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-test-women-ultrafit-court_777803d9-2db1-4500-b280-ef2c5a2c9dc4.jpg?v=1789185177',
      'Track Suits': 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-women-track.jpg?v=1789171725',
      'Performance Polo Shirts': 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-women-polo.jpg?v=1789171803',
      'Performance Outdoor Apparel': 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-women-outdoor.jpg?v=1789171792',
      "Women's Sunglasses": 'https://cdn.shopify.com/s/files/1/0645/1045/9994/files/sharp-test-women-sunglasses-concert.jpg?v=1789186780'
    };

    details.querySelectorAll('.sharp-mega-menu__link').forEach((link) => {
      const title = link.textContent.trim();
      if (title === 'T-Shirts') {
        link.closest('li')?.remove();
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(womenPreviews, title)) return;
      link.dataset.sharpPreview = womenPreviews[title];
      link.dataset.sharpPreviewLabel = title;
      if (title === 'Ultra Fit Shirts') link.dataset.sharpPreviewPosition = '50% 25%';
      if (title === "Women's Sunglasses") link.dataset.sharpPreviewPosition = '50% 32%';
    });
  };
  curateWomenMenu();

  const updateMenuTop = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--sharp-nav-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
  };

  const syncBackdrop = () => {
    const anyOpen = menus.some((menu) => getDetails(menu)?.hasAttribute('open'));
    document.body.classList.toggle('sharp-nav-open', anyOpen && desktopHover.matches);
  };

  const getPreviewParts = (menu) => {
    const panel = getDetails(menu)?.querySelector('.sharp-mega-menu');
    if (!panel) return {};
    return {
      frame: panel.querySelector('[data-sharp-preview-frame]'),
      image: panel.querySelector('[data-sharp-preview-image]'),
      label: panel.querySelector('.sharp-mega-menu__preview-label')
    };
  };

  const clearPreview = (menu) => {
    const { frame, label } = getPreviewParts(menu);
    if (!frame || !label) return;
    frame.dataset.previewToken = '';
    frame.dataset.previewUrl = '';
    frame.classList.remove('is-visible');
    label.textContent = '';
  };

  const setPreview = (menu, source) => {
    const { frame, image, label } = getPreviewParts(menu);
    if (!frame || !image || !label) return;
    const url = source?.dataset?.sharpPreview;
    const text = source?.dataset?.sharpPreviewLabel || source?.textContent?.trim() || '';
    const position = source?.dataset?.sharpPreviewPosition || '50% 50%';
    if (!url) {
      clearPreview(menu);
      return;
    }
    if (frame.dataset.previewUrl === url && frame.classList.contains('is-visible')) {
      label.textContent = text;
      image.style.objectPosition = position;
      return;
    }
    const token = `${Date.now()}-${Math.random()}`;
    frame.dataset.previewToken = token;
    const loader = new Image();
    loader.decoding = 'async';
    loader.onload = () => {
      if (frame.dataset.previewToken !== token) return;
      image.src = url;
      image.style.objectPosition = position;
      label.textContent = text;
      frame.dataset.previewUrl = url;
      requestAnimationFrame(() => {
        if (frame.dataset.previewToken === token) frame.classList.add('is-visible');
      });
    };
    loader.onerror = () => {
      if (frame.dataset.previewToken === token) clearPreview(menu);
    };
    loader.src = url;
  };

  const setDefaultPreview = (menu) => {
    const details = getDetails(menu);
    if (!details) return;
    const source = Array.from(details.querySelectorAll('[data-sharp-preview]'))
      .find((link) => link.matches(':hover, :focus'));
    if (source) setPreview(menu, source);
    else clearPreview(menu);
  };

  const setOpen = (menu, open) => {
    const details = getDetails(menu);
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;
    if (open) updateMenuTop();
    else clearPreview(menu);
    details.toggleAttribute('open', open);
    summary.setAttribute('aria-expanded', String(open));
    syncBackdrop();
  };

  const closeOthers = (current) => {
    menus.forEach((menu) => {
      if (menu === current) return;
      clearTimeout(menu._sharpHoverTimer);
      setOpen(menu, false);
    });
  };

  menus.forEach((menu) => {
    const details = getDetails(menu);
    if (!details) return;

    const summary = details.querySelector(':scope > summary');
    let touchTap = false;
    summary?.addEventListener('pointerdown', (event) => { touchTap = event.pointerType === 'touch' || event.pointerType === 'pen'; });
    summary?.addEventListener('click', (event) => {
      if (!touchTap && desktopHover.matches) return;
      touchTap = false;
      event.preventDefault();
      event.stopImmediatePropagation();
      const open = !details.open;
      closeOthers(menu);
      clearTimeout(menu._sharpHoverTimer);
      setOpen(menu, open);
    }, true);

    const panel = details.querySelector('.sharp-mega-menu');
    if (panel) {
      panel.addEventListener('pointermove', (event) => {
        if (!desktopHover.matches || !details.hasAttribute('open')) return;
        const links = Array.from(panel.querySelectorAll('.sharp-mega-menu__link, .sharp-team-link'))
          .filter((link) => link.offsetParent !== null);
        if (!links.length) return;
        const lowestLinkBottom = Math.max(...links.map((link) => link.getBoundingClientRect().bottom));
        if (event.clientY > lowestLinkBottom + 10) {
          clearTimeout(menu._sharpHoverTimer);
          setOpen(menu, false);
        }
      }, { passive: true });
    }

    details.addEventListener('toggle', () => {
      if (details.open) setDefaultPreview(menu);
      else clearPreview(menu);
      syncBackdrop();
    });
    details.querySelectorAll('.sharp-mega-menu__link, .sharp-team-link').forEach((link) => {
      link.addEventListener('pointerdown', () => clearTimeout(menu._sharpHoverTimer));
      link.addEventListener('click', (event) => event.stopPropagation());
    });
    details.querySelectorAll('[data-sharp-preview]').forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (desktopHover.matches) setPreview(menu, link);
      });
      link.addEventListener('focus', () => setPreview(menu, link));
    });
    menu.addEventListener('mouseenter', () => {
      if (!desktopHover.matches) return;
      clearTimeout(menu._sharpHoverTimer);
      closeOthers(menu);
      setOpen(menu, true);
    });
    menu.addEventListener('mouseleave', () => {
      if (!desktopHover.matches) return;
      clearTimeout(menu._sharpHoverTimer);
      menu._sharpHoverTimer = setTimeout(() => setOpen(menu, false), 170);
    });
  });

  window.addEventListener('resize', updateMenuTop, { passive: true });
  window.addEventListener('scroll', updateMenuTop, { passive: true });
  desktopHover.addEventListener('change', (event) => {
    if (event.matches) {
      updateMenuTop();
      return;
    }
    menus.forEach((menu) => {
      clearTimeout(menu._sharpHoverTimer);
      setOpen(menu, false);
    });
    document.body.classList.remove('sharp-nav-open');
  });
  updateMenuTop();
})();

/* Native rubber-band Easter egg. The verse sits directly behind the dropdown edge beneath the logo, so Safari's own overscroll gap reveals it and native snapback hides it again. */
(() => {
  const init = () => {
    if (matchMedia('(max-width:989px)').matches) return;
    document.querySelectorAll('.sharp-universal-overscroll, .sharp-overscroll-easter-egg').forEach((node) => node.remove());
    document.getElementById('sharp-native-overscroll-style')?.remove();

    const wrapper = document.querySelector('.header-wrapper');
    const header = wrapper?.querySelector('header') || document.querySelector('header.header');
    const logo = header?.querySelector('.header__heading-link, .header__heading-logo-wrapper');
    if (!wrapper || !header || !logo) return;

    const reveal = document.createElement('div');
    reveal.className = 'sharp-overscroll-easter-egg';
    reveal.setAttribute('aria-hidden', 'true');
    reveal.textContent = 'PHILIPPIANS 4:13';
    wrapper.prepend(reveal);

    const style = document.createElement('style');
    style.id = 'sharp-native-overscroll-style';
    style.textContent = `
      html, body { overscroll-behavior-y: auto !important; }
      .header-wrapper { overflow: visible !important; }
      .sharp-overscroll-easter-egg {
        position: absolute;
        top: var(--sharp-egg-top, 100%);
        left: var(--sharp-egg-left, 50%);
        transform: translateX(-50%);
        pointer-events: none;
        white-space: nowrap;
        color: var(--sharp-easter-egg-color, #111);
        mix-blend-mode: normal;
        background: transparent;
        font-family: var(--font-heading-family, Arial, sans-serif);
        font-size: 11px;
        font-weight: 800;
        line-height: 1;
        letter-spacing: .16em;
        text-transform: uppercase;
        opacity: 0;
        visibility: hidden;
      }
      body.sharp-nav-open .sharp-overscroll-easter-egg {
        opacity: 1;
        visibility: visible;
      }
      @media (max-width: 989px) {
        .sharp-overscroll-easter-egg { font-size: 10px; font-weight: 800; }
      }
    `;
    document.head.appendChild(style);

    const positionReveal = () => {
      const wrapperRect = wrapper.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();
      const logoRect = logo.getBoundingClientRect();
      const left = logoRect.left + (logoRect.width / 2) - wrapperRect.left;
      const top = headerRect.bottom - wrapperRect.top + 15;
      reveal.style.setProperty('--sharp-egg-left', `${Math.round(left)}px`);
      reveal.style.setProperty('--sharp-egg-top', `${Math.round(top)}px`);
    };

    positionReveal();
    window.addEventListener('resize', positionReveal, { passive: true });
    window.addEventListener('orientationchange', () => setTimeout(positionReveal, 120), { passive: true });
    document.addEventListener('shopify:section:load', () => requestAnimationFrame(positionReveal));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Sharp storefront quality-of-life enhancements. */
(() => {
  const ensureStyles = () => {
    if (document.getElementById('sharp-qol-ui-style')) return;
    const style = document.createElement('style');
    style.id = 'sharp-qol-ui-style';
    style.textContent = `
      .sharp-home-showcase__dots { gap: 5px !important; flex-wrap: nowrap !important; }
      .sharp-home-showcase__dot[data-sharp-catalog-label] {
        width: auto !important;
        min-width: 0 !important;
        height: 28px !important;
        padding: 0 9px !important;
        border: 1px solid rgba(16,16,18,.16) !important;
        border-radius: 999px !important;
        background: rgba(255,255,255,.84) !important;
        color: rgba(16,16,18,.72) !important;
        opacity: 1 !important;
        font-family: var(--font-heading-family, Arial, sans-serif) !important;
        font-size: 9px !important;
        font-weight: 800 !important;
        line-height: 1 !important;
        letter-spacing: .07em !important;
        text-transform: uppercase !important;
        white-space: nowrap !important;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
      }
      .sharp-home-showcase__dot[data-sharp-catalog-label].is-active {
        width: auto !important;
        background: rgba(16,16,18,.92) !important;
        border-color: rgba(16,16,18,.92) !important;
        color: #fff !important;
      }
      .sharp-team-search { margin: 0 0 1.35rem; }
      .sharp-team-search__label {
        display: block;
        margin: 0 0 .65rem;
        color: rgba(247,247,245,.64);
        font-size: 1.05rem;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
      }
      .sharp-team-search__input {
        width: 100%;
        min-height: 46px;
        padding: 0 1.35rem;
        border: 1px solid rgba(255,255,255,.20);
        border-radius: 999px;
        outline: none;
        background: #0b0b0b;
        color: #f7f7f5;
        font: inherit;
      }
      .sharp-team-search__input::placeholder { color: rgba(247,247,245,.42); }
      .sharp-team-search__input:focus { border-color: rgba(255,255,255,.62); box-shadow: 0 0 0 2px rgba(255,255,255,.08); }
      .sharp-team-search__status { min-height: 1.5em; margin: .6rem 0 0; color: rgba(247,247,245,.54); font-size: 1.2rem; }
      .sharp-qol-size-attention { outline: 2px solid currentColor; outline-offset: 8px; border-radius: 8px; }
      .sharp-mobile-buy-bar { display: none; }
      @media screen and (max-width: 749px) {
        .sharp-home-showcase__dot[data-sharp-catalog-label] { height: 26px !important; padding: 0 8px !important; font-size: 8.5px !important; }
        .sharp-mobile-buy-bar {
          position: fixed;
          left: 12px;
          right: 12px;
          bottom: calc(12px + env(safe-area-inset-bottom));
          z-index: 70;
          display: grid;
          grid-template-columns: minmax(0,1fr) auto;
          align-items: center;
          gap: 10px;
          padding: 10px 10px 10px 14px;
          border: 1px solid rgba(255,255,255,.14);
          border-radius: 18px;
          background: rgba(8,8,9,.94);
          box-shadow: 0 16px 48px rgba(0,0,0,.28);
          color: #fff;
          opacity: 0;
          transform: translateY(calc(100% + 28px));
          pointer-events: none;
          transition: opacity .22s ease, transform .28s cubic-bezier(.22,.61,.36,1);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
        }
        .sharp-mobile-buy-bar.is-visible { opacity: 1; transform: translateY(0); pointer-events: auto; }
        .sharp-mobile-buy-bar__copy { min-width: 0; }
        .sharp-mobile-buy-bar__title { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 11px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase; }
        .sharp-mobile-buy-bar__price { margin-top: 2px; color: rgba(255,255,255,.68); font-size: 12px; line-height: 1.2; }
        .sharp-mobile-buy-bar__button {
          min-width: 118px;
          min-height: 44px;
          padding: 0 15px;
          border: 0;
          border-radius: 999px;
          background: #fff;
          color: #111;
          font: inherit;
          font-size: 11px;
          font-weight: 900;
          letter-spacing: .06em;
          text-transform: uppercase;
          cursor: pointer;
        }
        .sharp-mobile-buy-bar__button:disabled { opacity: .45; cursor: default; }
      }
      @media screen and (max-width: 390px) {
        .sharp-home-showcase__dot[data-sharp-catalog-label] { padding: 0 6px !important; font-size: 7.7px !important; letter-spacing: .04em !important; }
        .sharp-mobile-buy-bar__button { min-width: 106px; padding: 0 12px; font-size: 10px; }
      }
    `;
    document.head.appendChild(style);
  };

  const cleanText = (value = '') => value.replace(/\s+/g, ' ').trim();
  const shortCatalogName = (name) => {
    if (/camo/i.test(name)) return 'Camo';
    if (/ultra/i.test(name)) return 'Ultra Fit';
    if (/bag/i.test(name)) return 'Bags';
    if (/track/i.test(name)) return 'Tracksuits';
    if (/polo/i.test(name)) return 'Polo';
    return cleanText(name).replace(/^Sharp\s+/i, '').slice(0, 16) || 'Catalog';
  };

  const initTeamDirectories = (root = document) => {
    const directories = root.matches?.('.sharp-custom__directory')
      ? [root]
      : [...root.querySelectorAll('.sharp-custom__directory')];

    directories.forEach((directory, directoryIndex) => {
      if (directory.dataset.sharpSearchReady === 'true') return;
      const list = directory.querySelector('.sharp-custom__teams');
      if (!list) return;
      const items = [...list.children].filter((item) => item.matches('li'));
      if (!items.length) return;

      const teamName = (item) => cleanText(item.querySelector('.sharp-team-link__name')?.textContent || item.textContent);
      items
        .sort((a, b) => teamName(a).localeCompare(teamName(b), undefined, { sensitivity: 'base' }))
        .forEach((item) => list.appendChild(item));

      const search = document.createElement('div');
      search.className = 'sharp-team-search';
      const inputId = `sharp-team-search-${directoryIndex}-${Math.random().toString(36).slice(2, 7)}`;
      search.innerHTML = `
        <label class="sharp-team-search__label" for="${inputId}">Find your school or team</label>
        <input class="sharp-team-search__input" id="${inputId}" type="search" autocomplete="off" placeholder="Search schools and teams" aria-controls="${list.id || ''}">
        <p class="sharp-team-search__status" aria-live="polite"></p>
      `;
      list.before(search);
      const input = search.querySelector('input');
      const status = search.querySelector('.sharp-team-search__status');

      const filterTeams = () => {
        const query = cleanText(input.value).toLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const matches = !query || teamName(item).toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        status.textContent = query && visible === 0 ? 'No matching team yet.' : '';
      };

      input.addEventListener('input', filterTeams);
      directory.dataset.sharpSearchReady = 'true';
    });
  };

  const initCatalogSections = (root = document) => {
    const sections = root.matches?.('[data-sharp-home-opening]')
      ? [root]
      : [...root.querySelectorAll('[data-sharp-home-opening]')];

    sections.forEach((section) => {
      if (section.dataset.sharpQolReady === 'true' || section.dataset.sharpQolPending === 'true') return;
      section.dataset.sharpQolPending = 'true';
      let attempts = 0;

      const waitForCore = () => {
        if (!section.isConnected) return;
        if (section.dataset.sharpInitialized !== 'true') {
          attempts += 1;
          if (attempts < 80) window.setTimeout(waitForCore, 50);
          else delete section.dataset.sharpQolPending;
          return;
        }

        delete section.dataset.sharpQolPending;
        if (section.dataset.sharpQolReady === 'true') return;
        section.dataset.sharpQolReady = 'true';

        const showcase = section.querySelector('[data-sharp-showcase]');
        const slides = [...section.querySelectorAll('[data-sharp-slide]')];
        const dotsWrap = section.querySelector('[data-sharp-dots]');
        if (!showcase || !slides.length) return;

        let pauseTimer = null;
        let touchStartX = 0;
        let touchStartY = 0;
        let trackingTouch = false;
        let suppressClickUntil = 0;
        let lastActive = -1;
        let pendingSource = '';

        const getActiveIndex = () => {
          const index = slides.findIndex((slide) => slide.classList.contains('is-active'));
          return index >= 0 ? index : 0;
        };
        const getCatalogName = (index = getActiveIndex()) => cleanText(
          slides[index]?.dataset.catalogName ||
          slides[index]?.querySelector('.sharp-home-showcase__meta strong')?.textContent ||
          `Catalog ${index + 1}`
        );
        const emitCatalogEvent = (action, source) => {
          const index = getActiveIndex();
          const detail = { action, catalogName: getCatalogName(index), index, position: index + 1, source };
          window.dispatchEvent(new CustomEvent('sharp:catalog', { detail }));
          if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `sharp_catalog_${action}`, ...detail });
        };
        const decorateDots = () => {
          if (!dotsWrap) return;
          [...dotsWrap.querySelectorAll('.sharp-home-showcase__dot')].forEach((dot, index) => {
            dot.textContent = shortCatalogName(getCatalogName(index));
            dot.dataset.sharpCatalogLabel = 'true';
          });
        };
        const pauseAfterManualAction = () => {
          window.clearTimeout(pauseTimer);
          showcase.dispatchEvent(new Event('mouseenter'));
          pauseTimer = window.setTimeout(() => {
            pauseTimer = null;
            if (showcase.matches(':hover')) return;
            showcase.dispatchEvent(new Event('mouseleave'));
          }, 8000);
        };

        const handleControlClick = (event) => {
          const catalogLink = event.target.closest('.sharp-home-showcase__slide-link');
          if (catalogLink && showcase.contains(catalogLink)) {
            if (Date.now() < suppressClickUntil) {
              event.preventDefault();
              event.stopImmediatePropagation();
              return;
            }
            emitCatalogEvent('click', 'catalog-link');
            return;
          }

          const dot = event.target.closest('.sharp-home-showcase__dot');
          if (dot && section.contains(dot)) {
            pendingSource = 'dot';
            pauseAfterManualAction();
            requestAnimationFrame(() => emitCatalogEvent('interaction', 'dot'));
            return;
          }
          if (event.target.closest('[data-sharp-prev]')) {
            pendingSource = 'previous';
            pauseAfterManualAction();
            requestAnimationFrame(() => emitCatalogEvent('interaction', 'previous'));
            return;
          }
          if (event.target.closest('[data-sharp-next]')) {
            pendingSource = 'next';
            pauseAfterManualAction();
            requestAnimationFrame(() => emitCatalogEvent('interaction', 'next'));
          }
        };

        const handleTouchStart = (event) => {
          if (event.touches.length !== 1) {
            trackingTouch = false;
            return;
          }
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          trackingTouch = true;
        };
        const handleTouchEnd = (event) => {
          if (!trackingTouch || event.changedTouches.length !== 1) return;
          trackingTouch = false;
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          const deltaY = event.changedTouches[0].clientY - touchStartY;
          if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
          pendingSource = 'swipe';
          suppressClickUntil = Date.now() + 450;
          pauseAfterManualAction();
          requestAnimationFrame(() => emitCatalogEvent('interaction', deltaX < 0 ? 'swipe-left' : 'swipe-right'));
        };
        const handleTouchCancel = () => { trackingTouch = false; };

        const slideObserver = new MutationObserver(() => {
          const current = getActiveIndex();
          if (current === lastActive) return;
          lastActive = current;
          emitCatalogEvent('impression', pendingSource || 'auto');
          pendingSource = '';
        });
        slides.forEach((slide) => slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] }));

        const dotsObserver = new MutationObserver(decorateDots);
        if (dotsWrap) dotsObserver.observe(dotsWrap, { childList: true });
        decorateDots();

        section.addEventListener('click', handleControlClick, true);
        showcase.addEventListener('touchstart', handleTouchStart, { passive: true });
        showcase.addEventListener('touchend', handleTouchEnd, { passive: true });
        showcase.addEventListener('touchcancel', handleTouchCancel, { passive: true });

        requestAnimationFrame(() => {
          lastActive = getActiveIndex();
          emitCatalogEvent('impression', 'initial');
        });

        section._sharpQolCleanup = () => {
          window.clearTimeout(pauseTimer);
          slideObserver.disconnect();
          dotsObserver.disconnect();
          section.removeEventListener('click', handleControlClick, true);
          showcase.removeEventListener('touchstart', handleTouchStart);
          showcase.removeEventListener('touchend', handleTouchEnd);
          showcase.removeEventListener('touchcancel', handleTouchCancel);
          delete section.dataset.sharpQolReady;
        };
      };

      waitForCore();
    });
  };

  let buyBarCleanup = null;
  const initMobileBuyBar = () => {
    buyBarCleanup?.();
    buyBarCleanup = null;
    document.getElementById('sharp-mobile-buy-bar')?.remove();
    if (!window.location.pathname.startsWith('/products/')) return;

    const getInfo = () => [...document.querySelectorAll('product-info')]
      .find((node) => !node.closest('quick-add-modal, .quick-add-modal'));
    const info = getInfo();
    if (!info) return;
    const getSubmit = () => getInfo()?.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
    if (!getSubmit()) return;

    // Dawn replaces variant-selects after an option change. Resolve its live
    // fieldset whenever needed rather than scrolling a detached initial node.
    const getSizePicker = () => [...(getInfo()?.querySelectorAll('.product-form__input') || [])]
      .find((group) => /size/i.test(cleanText(group.querySelector('legend, label')?.textContent || '')));
    let sizeRequired = false;
    const needsExplicitSize = () => {
      const picker = getSizePicker();
      if (!picker) return sizeRequired;
      const choices = picker ? [...picker.querySelectorAll('input[type="radio"]:not([disabled]), select option:not([disabled])')]
        .filter((choice) => choice.tagName !== 'OPTION' || cleanText(choice.value)) : [];
      sizeRequired = choices.length > 1;
      return sizeRequired;
    };
    let sizeTouched = false;

    const bar = document.createElement('div');
    bar.id = 'sharp-mobile-buy-bar';
    bar.className = 'sharp-mobile-buy-bar';
    bar.setAttribute('aria-label', 'Quick purchase');
    bar.innerHTML = `
      <div class="sharp-mobile-buy-bar__copy">
        <div class="sharp-mobile-buy-bar__title"></div>
        <div class="sharp-mobile-buy-bar__price"></div>
      </div>
      <button class="sharp-mobile-buy-bar__button" type="button"></button>
    `;
    document.body.appendChild(bar);
    const titleNode = bar.querySelector('.sharp-mobile-buy-bar__title');
    const priceNode = bar.querySelector('.sharp-mobile-buy-bar__price');
    const button = bar.querySelector('.sharp-mobile-buy-bar__button');
    const mobile = window.matchMedia('(max-width: 749px)');

    const getPrice = () => {
      const selectors = ['.price__sale .price-item--sale', '.price__regular .price-item--regular', '.price-item'];
      for (const selector of selectors) {
        const match = [...(getInfo()?.querySelectorAll(selector) || [])].find((node) => node.offsetParent !== null);
        if (match) return cleanText(match.textContent);
      }
      return '';
    };
    const getButtonLabel = (submit) => cleanText(submit.querySelector('span')?.textContent || submit.textContent) || 'Add to cart';
    const updateBar = () => {
      const currentInfo = getInfo();
      const submit = getSubmit();
      if (!currentInfo || !submit) {
        button.disabled = true;
        bar.classList.remove('is-visible');
        return;
      }
      titleNode.textContent = cleanText((currentInfo.querySelector('.product__title h1, h1, .product__title h2') || currentInfo.querySelector('.product__title'))?.textContent || document.title.split('–')[0]);
      priceNode.textContent = getPrice();
      const chooseSize = needsExplicitSize() && !sizeTouched;
      button.textContent = chooseSize ? 'Choose size' : getButtonLabel(submit);
      button.disabled = chooseSize ? false : submit.disabled;
      const submitRect = submit.getBoundingClientRect();
      bar.classList.toggle('is-visible', mobile.matches && submitRect.bottom < 0);
    };

    let frame = 0;
    const scheduleUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        updateBar();
      });
    };
    const handleVariantChange = (event) => {
      if (!getInfo()?.contains(event.target)) return;
      if (getSizePicker()?.contains(event.target)) sizeTouched = true;
      scheduleUpdate();
    };
    let attentionTimer = 0;
    let jumpFrame = 0;
    const handleBarClick = () => {
      const currentInfo = getInfo();
      const submit = getSubmit();
      if (!currentInfo || !submit) return;
      if (needsExplicitSize() && !sizeTouched) {
        const target = getSizePicker() || currentInfo.querySelector('variant-selects') || currentInfo;
        let ancestor = target.parentElement;
        while (ancestor && currentInfo.contains(ancestor)) {
          if (ancestor.tagName === 'DETAILS') ancestor.open = true;
          ancestor = ancestor.parentElement;
        }
        if (jumpFrame) cancelAnimationFrame(jumpFrame);
        jumpFrame = requestAnimationFrame(() => {
          jumpFrame = 0;
          if (!target.isConnected) { scheduleUpdate(); return; }
          const header = document.querySelector('sticky-header, .section-header, .header-wrapper');
          const headerOffset = Math.max(0, header?.getBoundingClientRect().height || 0) + 16;
          const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset);
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          window.scrollTo({ top, behavior });
          target.querySelector('input[type="radio"]:not([disabled]), select:not([disabled]), button:not([disabled])')?.focus({ preventScroll: true });
          target.classList.add('sharp-qol-size-attention');
          window.clearTimeout(attentionTimer);
          attentionTimer = window.setTimeout(() => target.classList.remove('sharp-qol-size-attention'), 1300);
        });
        return;
      }
      // Mirror the live product form's restrictions; never add an unavailable variant.
      if (!submit.disabled) submit.click();
    };

    document.addEventListener('change', handleVariantChange);
    button.addEventListener('click', handleBarClick);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    mobile.addEventListener?.('change', scheduleUpdate);
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(info, { childList: true, subtree: true, attributes: true, characterData: true });
    updateBar();

    buyBarCleanup = () => {
      if (frame) cancelAnimationFrame(frame);
      observer.disconnect();
      document.removeEventListener('change', handleVariantChange);
      if (jumpFrame) cancelAnimationFrame(jumpFrame);
      window.clearTimeout(attentionTimer);
      button.removeEventListener('click', handleBarClick);
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      mobile.removeEventListener?.('change', scheduleUpdate);
      bar.remove();
    };
  };

  const boot = (root = document) => {
    ensureStyles();
    initTeamDirectories(root);
    initCatalogSections(root);
    initMobileBuyBar();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.('[data-sharp-home-opening]')
      ? event.target
      : event.target.querySelector?.('[data-sharp-home-opening]');
    section?._sharpQolCleanup?.();
  });
  document.addEventListener('product-info:loaded', () => requestAnimationFrame(initMobileBuyBar));
})();

